<app-pan-form-control>
  <app-pan-floating-label>{{ label() }}</app-pan-floating-label>
  <ng-select
    data-testid="page-select-branch-control"
    appendTo="body"
    [placeholder]="placeholder()"
    [bindLabel]="'name'"
    [virtualScroll]="true"
    [items]="visibleBranches()"
    [multiple]="multi()"
    [ngModel]="selected()"
    (ngModelChange)="selected.set($event)"
    [loading]="isLoading()"
    loadingText="Loading branches..."
    [disabled]="disabled()"
    clearAllText="Clear selection"
    [searchFn]="customSearchFn"
  >
    <ng-template ng-label-tmp let-item="item" let-clear="clear">
      <div class="flex items-center">
        <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
        <span>
          {{ item.name }}
          @if (showExternalId() && item.external_id) {
            ({{ item.external_id }})
          }
        </span>

        @if (showIncidentIcon()) {
          <app-pan-incident-status
            class="flex items-center px-2"
            [status]="item.has_recent_incidents ? 'has-incident' : 'hidden'">
          </app-pan-incident-status>
        }
      </div>
    </ng-template>

    <ng-template ng-option-tmp let-item="item">
      <div
        class="flex justify-between items-center"
        [class.opacity-50]="item.disabled"
        [attr.title]="item.disabled ? 'Branch access is suspended' : null"
      >
        <span>
          {{ item.name }}
          @if (showExternalId() && item.external_id) {
            ({{ item.external_id }})
          }
          @if (item.disabled) {
            [Access Suspended]
          }
        </span>

        @if (showIncidentIcon()) {
          <app-pan-incident-status 
            [status]="item.has_recent_incidents ? 'has-incident' : 'hidden'">
          </app-pan-incident-status>
        }
      </div>
    </ng-template>
  </ng-select>
</app-pan-form-control>
